export default "__VITE_ASSET__BMd0RttH__"